<template>
  <div>
    <h5 class="mb-3">Logs de troca de cliente</h5>
    <div class="row">
      <div class="col-md-12 mb-2">
        <form :action="$store.state.url + 'customer_change_logs/'" id="export-customer-change" method="get">
          <div class="block text-right">
            <button class="btn btn-success white float-right" type="submit">
              Exportar trocas de cliente <i class="fa fa-file-export"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <base-table
      :ref="table"
      :filters="filters"
      :crudName="crudName"
      :newText="newText"
      :table="table"
      :endPoint="endPoint"
      :enableAdd="false"
      :enableEdit="false"
      :enableDelete="false"
      :relationships="relationships"
      :extras="extras"
      :columns="columns"
      :enableExtract="false"
      :orders="orders"
    ></base-table>
  </div>
</template>

<script>
import BaseTable from "@/components/Layouts/BaseTable.vue";

export default {
  data() {
    return {
      extras: [],
      crudName: "Trocas de Cliente",
      filters: [
        {
          id: "user_name",
          name: "user_name",
          label: "Nome do Usuário",
          value: "",
          type: "text",
          class: "form-control",
          columnSize: "col-3",
        },
        {
          id: "source",
          name: "source",
          label: "Origem",
          value: "",
          type: "select",
          class: "form-control",
          columnSize: "col-3",
          options: [
            { value: "", label: "Todas" },
            { value: "change_customer", label: "Troca no portal" },
            { value: "user_update", label: "Atualização de usuário" },
          ],
        },
        {
          id: "status",
          name: "status",
          label: "Status",
          value: "",
          type: "select",
          class: "form-control",
          columnSize: "col-3",
          options: [
            { value: "", label: "Todos" },
            { value: "success", label: "Sucesso" },
            { value: "error", label: "Erro" },
          ],
        },
      ],
      newText: "",
      table: "customer_change_logs",
      endPoint: "customer_change_logs/",
      relationships: [],
      orders: [],
      columns: [
        { label: "ID", field: "id" },
        { label: "Usuário", field: "user_name" },
        { label: "Alterado por", field: "changed_by_name" },
        { label: "Origem", field: "source_label" },
        { label: "Status", field: "status_label" },
        { label: "Cliente anterior", field: "previous_customer_name" },
        { label: "Cliente novo", field: "new_customer_name" },
        { label: "Mensagem", field: "message" },
        { label: "IP", field: "ip" },
        { label: "Data", field: "created_at_f" },
      ],
    };
  },
  components: {
    BaseTable,
  },
};
</script>
